export interface Dictionary {
  id: string;
  code: string;
  lang: string;
  glossary: { [key: string]: any };
}
